<template>
  <div class="page home_page">
    <div class="content">
      <Search
        ref="search"
        :searchConfig="tableConfig"
        @doSearch="getList(1)"
        :resetEvent="true"
        @reset="resetDoSearch(dataForm)"
      >
        <template :slot="'btns'">
          <el-button
            class="plc-btn"
            style="display: none"
            size="small"
            @click="() => download('list')"
            :loading="loading"
          >
            导出列表
          </el-button>
          <el-button
            class="plc-btn"
            style="display: none"
            size="small"
            @click="() => download('detail')"
            :loading="loading"
          >
            导出明细
          </el-button>
          <ExportCom
            style="display: none"
            :templateCodeList="[
              {
                code: 'omsOrderQuestionnaireList',
                value: '导出列表'
              },
              {
                code: 'OrderQuestionnaireDetailList',
                value: '导出明细'
              }
            ]"
          />
        </template>
      </Search>
      <div class="table">
        <el-table
          :data="dataList"
          class="plc-table"
          height="100%"
          v-loading="dataLoading"
          border
        >
          <el-table-column
            type="index"
            header-align="center"
            align="center"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="orderCode"
            header-align="center"
            align="center"
            width="150px"
            label="订单编号"
          >
            <template slot-scope="scope">
              <a href="javascript:" @click="detailHandle(scope.row)">
                {{ scope.row.orderCode }}
              </a>
            </template>
          </el-table-column>
          <el-table-column
            prop="finalCompanyName"
            header-align="center"
            align="center"
            show-overflow-tooltip
            label="最终客户名称"
          ></el-table-column>
          <el-table-column
            prop="createUserName"
            header-align="center"
            align="center"
            label="下单人"
          ></el-table-column>
          <el-table-column
            prop="customerContractCode"
            header-align="center"
            align="center"
            label="客户合同号"
          ></el-table-column>
          <el-table-column
            prop="totalPay"
            header-align="center"
            align="right"
            label="订单金额（元）"
          >
            <template slot-scope="scope">
              {{ scope.row.totalPay | formatePrice }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderStatus"
            header-align="center"
            align="center"
            label="订单状态"
            width="100px"
          >
            <template slot-scope="scope">
              {{ $getDictLabel('OMS_PLC_ORDER_STATUS', scope.row.orderStatus) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="center"
            show-overflow-tooltip
            label="下单时间"
          ></el-table-column>
        </el-table>
      </div>
      <div class="plc-pagination">
        <el-pagination
          background
          :current-page="dataForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="dataForm.limit"
          :total="total"
          layout="total, prev, pager, next, sizes, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Search from './order/search.vue'
import ExportCom from './order/exportCom.vue'
import { Base64 } from 'js-base64'
import { shortcuts } from '@/utils/shortcuts'
import { formatePrice } from '@/utils/formatePrice'

export default {
  name: 'plcOrderList',
  components: {
    Search,
    ExportCom
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  data () {
    return {
      dataLoading: false,
      dataForm: {
        page: 1,
        limit: 20,
        companyIds: []
      },
      total: 0,
      dataList: [],
      tableConfig: {
        hideLabel: true,
        params: [
          {
            prop: 'orderCode',
            label: '订单编号',
            placeholder: '订单编号'
          },
          {
            prop: 'customerContractCode',
            label: '客户合同号',
            placeholder: '客户合同号'
          },
          // {
          //   prop: 'finalCompanyName',
          //   label: '最终客户名称',
          //   placeholder: '最终客户名称'
          // },
          {
            prop: 'createUserName',
            label: '下单人',
            placeholder: '下单人'
          },
          {
            prop: 'createTime',
            label: '下单时间',
            columnsType: 'date',
            sortable: true,
            searchType: 'datetimerange',
            props: ['createTimeStart', 'createTimeEnd'],
            pickerOptions: {
              shortcuts
            }
          },
          {
            prop: 'plcSkuCode',
            label: '中控商品编号（含）',
            placeholder: '中控商品编号（含）'
          },
          {
            prop: 'skuCode',
            label: '平台商品编号（含）',
            placeholder: '平台商品编号（含）'
          }
        ],
        extra: {} // 额外的参数 搜索的条件
      },
      companyList: [],
      downloadLoading: false,
      loading: false
    }
  },
  mounted () {
    this.dataForm.companyIds = [this.$store.state.user.defaultCompanyId]
    this.getList(1)
  },
  methods: {
    // 重置
    reset () {
      this.dataForm = {
        page: 1,
        limit: 10,
        companyList: [],
        companyIds: [this.$store.state.user.defaultCompanyId]
      }
      this.getList(1)
    },
    // 获取列表数据
    getList (page = this.dataForm.page) {
      this.dataForm.page = page
      if (this.dataLoading) {
        return false
      }
      this.dataLoading = true
      let obj = this.getParams()
      this.$http
        .post('/front/oms/plc/user/pageOrderList', obj)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.total = 0
            this.dataList = []
            return false
          }
          this.total = res.data.total - 0
          this.dataList = res.data.records || []
        })
        .catch(() => {
          this.dataList = []
          this.total = 0
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    // 更改分页条数
    pageSizeChangeHandle (val) {
      this.dataForm.limit = val
      this.getList(1)
    },
    currentChange (val) {
      this.dataForm.page = val
      this.getList()
    },
    // 查看详情
    detailHandle (row) {
      this.$router.push({
        path: '/plcOrderDetail',
        query: {
          id: Base64.encode(row.id)
        }
      })
    },
    // 清空form
    resetDoSearch (data) {
      this.dataForm.companyIds = [this.$store.state.user.defaultCompanyId]
      this.getList()
    },
    getParams () {
      let params = {
        ...this.$refs.search.getParams(),
        page: this.dataForm.page,
        limit: this.dataForm.limit,
        companyIds: this.dataForm.companyIds
      }
      return params
    },
    download (exportTemplate) {
      const dataForm = this.$refs.search.getParams()
      const obj = {
        requestBody: {
          ...dataForm
        },
        exportTemplate
      }
      this.loading = true
      this.$http
        .post(
          '/help/export-log-mgmt/v1/sys-exports/request-body-shared/create',
          obj
        )
        .then(({ data: res }) => {
          this.loading = false
          if (res.code !== 0) {
            return
          }
          this.$message.success('文件生成中,请稍后在导出历史中查看')
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: white;
  padding: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  ::v-deep .search-list {
    .item {
      width: 20%;
      &.search-btns {
        order: 6;
      }
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.table {
  flex: 1;
  overflow: hidden;
}
</style>
